var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import myHeader from './components/myHeader.vue';
import myFooter from './components/myFooter.vue';
import Downloads from './components/downloads.vue';
import { mapState, mapMutations } from 'vuex';
import LocalStorageMemory from './local-storage/local-storage';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css';
import './styles/style.scss';
import CountrySelector from './components/countries-selector/country-selector.vue';
import AboutMe from './components/about-me.vue';
import ShooterFrame from "./components/frames/shooterFrame.vue";
import { isMobile } from './my-common/common-func';
Vue.use(VueMaterial);
/**
 *  We declare the props separately
 *  to make props types inferable.
 */
var AppProps = Vue.extend({
    props: {
        AppPropVersion: String,
        AppDomainHost: String
    }
});
// Register for components
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    /**
     * @description Initial method construct.
     */
    function App() {
        var _this = _super.call(this) || this;
        /**
         * @description `ls` is instance for localstorage operation
         * I will use it like singletone for injection in places
         * where is needed.
         */
        _this.ls = new LocalStorageMemory();
        /**
         * @description options are main object
         * for user in fly setup. If user clear
         * cache memory(localStorege) everything
         * goes back to the default values.
         */
        _this.options = {};
        _this.setupInstance = function () {
            _this.currentRoute = window.location.pathname;
            _this.$refs.loader.style.display = 'none';
            // console.log('Test Application refs mybodycontent => ', this.$refs.mybodycontent)
        };
        if (isMobile()) {
            _this.fields = [AboutMe];
        }
        else {
            _this.fields = [AboutMe];
        }
        _this.inputBodyProps = {
            slogan: "Everything is possible"
        };
        _this.styleObject = {
            display: 'flex',
            flexDirection: 'column',
            height: '92vh',
            width: '100%'
        };
        /**
         * @description  Check page localStorage
         * Note: Only lower chars for naming ls objects.
         */
        if (_this.ls.load("first_time") === null) {
            console.info("App starts first time. Prepare storage data...");
            /**
             * In future enumerate for global config...
             */
            // this.ls.save("o_camera", false)
            /**
             * @description Permission staff
             * Cant be read or write
             */
            _this.ls.save("permission_level", "read");
            _this.options = {
                permissionLevel: _this.ls.load("permission_level"),
            };
            _this.ls.save("first_time", 'storage-loaded');
        }
        else {
            console.info("App loading storage data...");
            _this.options = {
                permissionLevel: _this.ls.load("permission_level")
            };
        }
        _this.$root.$on('global.copyclipboard', function (args) {
            try {
                console.info("Event global.copyclipboard => ", args);
            }
            catch (err) {
                console.warn(err);
            }
        });
        return _this;
    }
    App.prototype.data = function () {
        return {
            visibility: {
                welcomeNote: true,
            },
        };
    };
    Object.defineProperty(App.prototype, "computedMsg", {
        get: function () {
            return 'computed';
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.mounted = function () {
        this.setupInstance();
    };
    App.prototype.created = function () {
        console.log("App created.");
    };
    App.prototype.showDownloads = function () {
        this.fields = [Downloads];
    };
    App.prototype.showAbouts = function () {
        this.fields = [AboutMe];
    };
    App.prototype.showShooterFrame = function () {
        this.fields = [ShooterFrame];
    };
    App.prototype.showAboutsAndShooterFrame = function () {
        this.fields = [AboutMe];
    };
    App = __decorate([
        Component({
            components: {
                myHeader: myHeader,
                myFooter: myFooter,
                CountrySelector: CountrySelector,
                AboutMe: AboutMe,
                Downloads: Downloads,
                ShooterFrame: ShooterFrame
            },
            computed: mapState([
                'permission'
            ]),
            methods: mapMutations([
                'cookieAccept'
            ])
        })
    ], App);
    return App;
}(AppProps));
export default App;
